<template>
  <div id="simulation" class="result" :class="$mq">
    <Carousel @next="next()" :items="ranges"></Carousel>
    <div
      class="mail inline center"
      :class="$mq"
      v-if="!noSubscribe"
    >
      <div>
        <SendMail @send="sendMail()"></SendMail>
      </div>
      <div>
        <Print @generate="generatePdf()"></Print>
      </div>
    </div>
    <WarningPrice
      v-if="showTextWarning"
      @close="showTextWarning = false"
    ></WarningPrice>
    <Details
      :range="modalRange"
      v-if="showDetails"
      @close="showDetails = false"
    ></Details>
    <div class="information" :class="$mq">
      <Informations></Informations>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Services from "./components/Services";
import Informations from "./components/Informations";
import SendMail from "./components/SendMail";
import Print from "./components/Print";
import Carousel from "./simulation/Carousel";
import WarningPrice from "./components/WarningPrice";

export default {
  data() {
    return {
      showTextWarning: false,
      modalRange: null,
      showDetails: false,
      update: 0,
      simulationOrdered: [],
      rangeOptions: {
        wantFix: false,
        wantGreen: false,
        duration: 1,
      },
    };
  },
  computed: {
    ...mapState("contact", ["isPro"]),
    ...mapState("simulation", ["ranges"]),
    ...mapGetters("podium", ["rangesDesktop", "rangesMobile"]),
    ...mapGetters("common", ["isTestAchat"]),
    simulation: {
      get() {
        return this.$store.state.simulation.simulation;
      },
      set(value) {
        this.$store.commit("simulation/setSimulation", value);
      },
    },
    amountType() {
      return this.isPro ? "amountHTVA" : "amountTVAC";
    },
    annualAmount() {
      return this.isPro ? "annualAmount" : "annualAmountVAT";
    },
    monthlyAmount() {
      return this.isPro ? "monthlyAmount" : "monthlyAmountVAT";
    },
    podium() {
      return this.$mq === "mobile" ? this.rangesMobile : this.rangesDesktop;
    },
    noSubscribe() {
      return this.$router.currentRoute.query.noSubscribe !== undefined || this.$store.state.common.noSubscribe;
    },
  },
  methods: {
    sendMail() {
      this.$store.dispatch("simulation/sendMail");
    },
    generatePdf() {
      this.$store.dispatch("simulation/generatePdf");
    },
    become(range) {
      return this.$store.getters["middleware/become"](range);
    },
    orderSimulation() {
      this.ranges.forEach((range) => {
        this.simulationOrdered.push(range);
      });
    },
    showProduct(index) {
      if (this.podium.length > 1) {
        if (this.$mq !== "mobile") {
          if (index === 0) {
            let tmp = this.simulationOrdered[this.simulationOrdered.length - 1];
            this.simulationOrdered.pop();
            this.simulationOrdered.unshift(tmp);
          } else if (index === this.simulationOrdered.length - 1) {
            let tmp = this.simulationOrdered[0];
            this.simulationOrdered.shift();
            this.simulationOrdered.push(tmp);
          }
        } else {
          if (index < 2) {
            let tmp = this.simulationOrdered[2];
            this.simulationOrdered.pop();
            this.simulationOrdered.unshift(tmp);
          }
        }
      }
    },
    getPosition(index) {
      let positions = ["second", "first", "third"];

      if (this.podium.length > 1) {
        positions = ["second", "first", "third"];
        if (this.$mq === "mobile") {
          positions = ["third", "second", "first"];
        }
      } else {
        positions = ["first"];
      }

      return positions[index];
    },
    newRange(newRange) {
      let index = this.simulationOrdered.indexOf(
        this.simulation[newRange.name]
      );
      // Save session?
      this.simulation[newRange.name] = newRange;
      this.simulationOrdered[index] = newRange;
      this.$store.dispatch("simulation/save", this.simulationOrdered);
      this.update++;
    },
    showModal(range) {
      this.modalRange = range;
      this.showDetails = true;
    },
  },
  filters: {
    toCurrency: function (value) {
      return value.toFixed(2).replace(".", ",");
    },
  },
  created() {
    this.$store.dispatch("simulation/save", this.simulationOrdered);
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "cookie-acceptation_true",
      "cookie-acceptation": "true",
    });
    if(this.isTestAchat) {
        dataLayer.push({
          'event' : 'specAgent',
          'value' : 'AG000132'
        });
      }
    window.scrollTo(0, 0);
    this.orderSimulation();
  },
  components: {
    Services,
    Carousel,
    // Product,
    // Details,
    Informations,
    SendMail,
    Print,
    WarningPrice,
  },
};
</script>

<style lang="scss" scoped>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
.relative {
  position: relative;
}

.mobile .result {
  margin: 0;
}

.product {
  transition: all 0.6s;
  width: 30%;
  min-width: 250px;
  border-top: 15px solid #fdcb47;
  border-radius: 30px;
  margin-top: 30px;
  background: white;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.1);
}

.mail {
  div {
    margin-bottom: 5px;
    margin-right: 5px;
  }

  &.mobile {
    margin-top: 20px;

    div {
      margin-right: 0;
    }
  }

  padding: 10px 0;

  a {
    cursor: pointer;
    min-width: 200px;
    text-decoration: underline;
    font-size: 0.8rem;
    color: #ccc;
  }
}

.mail.mobile {
  // padding-top: 120px;
}

.information.mobile {
  margin: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Simulation.vue